import { render, staticRenderFns } from "./notMatch.vue?vue&type=template&id=d33f9c58&scoped=true"
import script from "./notMatch.vue?vue&type=script&lang=js"
export * from "./notMatch.vue?vue&type=script&lang=js"
import style0 from "./notMatch.vue?vue&type=style&index=0&id=d33f9c58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33f9c58",
  null
  
)

export default component.exports